import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d8a7f7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./workbench.less?vue&type=style&index=0&id=4d8a7f7a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a7f7a",
  null
  
)

export default component.exports